<div>
  <p-select optionLabel="Name" dataKey="CustomFieldID"
    placeholder="{{ 'profiles.edit.custom-fields.select-label' | translate }}" [options]="customFields"
    [style]="{ 'max-width': '200px' }" [(ngModel)]="selectedCustomField"></p-select>
</div>

<div class="mv-20" *ngFor="let profileCustomField of profileCustomFields; index as i">
  <div *ngFor="let field of hiddenCustomFields">
    <wl-profile-custom-field *ngIf="field.CustomFieldID == profileCustomField.CustomFieldId"
      [(profileCustomField)]="profileCustomFields[i]" [(field)]="field" [editable]="true"
      (delete)="deleteField(i)"></wl-profile-custom-field>
  </div>
</div>